import Detailed from "components/recoveries/recovery-groups/controls/detailed"
import DeleteConfirmation from "components/modal/delete-confirmation"

export default {
  Detailed,
  DeleteConfirmation
}
